import React, { Component } from 'react';
import ReactGA from 'react-ga';
import $ from 'jquery';
import './App.css';
import Header from './Components/Header';
import Footer from './Components/Footer';
import About from './Components/About';
import Resume from './Components/Resume';
import Contact from './Components/Contact';
import Testimonials from './Components/Testimonials';
import Portfolio from './Components/Portfolio';
import axios from 'axios';
import MyGallery from './Components/Gallery';

class App extends Component {

  constructor(props){
    super(props);
    this.state = {
      foo: 'bar',
      resumeData: {},
      amount: [],
      currency: [],
      images: []
    };

    ReactGA.initialize('UA-110570651-1');
    ReactGA.pageview(window.location.pathname);

  }

  getResumeData(){
    $.ajax({
      url:'/resumeData.json',
      dataType:'json',
      cache: false,
      success: function(data){
        this.setState({resumeData: data});
      }.bind(this),
      error: function(xhr, status, err){
        console.log(err);
        // alert(err);
      }
    });
  }

  getAlgoPrice(){
    axios.get('https://api.coinbase.com/v2/prices/ALGO-USD/spot')
    .then((response) => {
       let amount = response.data.data.amount;
       let currency = response.data.data.currency;
       console.log('Algo Response: ' + response.status + 'Algo Price: ' + amount + 'In: ' + currency);
       this.setState({ amount });
       this.setState({ currency });
       document.getElementById('algocost').innerHTML = amount;
       document.getElementById('currency').innerHTML = currency;
    }).catch((e) => {
       console.log(e);
    });
  }

  componentDidMount(){
    this.getResumeData();
    this.getAlgoPrice();
  }

  render() {
    return (
      <div className="App">
        <Header data={this.state.resumeData.main}/>
        <About data={this.state.resumeData.main}/>
        <Resume data={this.state.resumeData.resume}/>
        <Portfolio data={this.state.resumeData.portfolio}/>
        <Testimonials data={this.state.resumeData.testimonials}/>
        <MyGallery/>
        <Contact data={this.state.resumeData.main}/>
        {/* <Carousel images={images} style={{ height: 800, width: 500 }} /> */}
        <Footer data={this.state.resumeData.main}/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js